import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import HomePage from '@/views/Home.vue'
import CategoriesPage from '@/views/Categories.vue'
import LoginPage from '@/views/Login.vue'
import RegisterPage from '@/views/Register.vue'
import ResultsPage from '@/views/Results.vue'
import BackofficePage from '@/views/Backoffice.vue'
import AdminLoginPage from '@/views/AdminLogin.vue'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history', // Use history mode for clean URLs
  routes: [
    { 
      path: '/', 
      name: 'Home', 
      component: HomePage,
      meta: {
        title: 'Home - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Participate in Sunway Multicare Pharmacy Top Choice Awards 2026 and win exciting prizes!'
      }
    },
    { 
      path: '/categories', 
      name: 'Categories', 
      component: CategoriesPage,
      meta: {
        title: 'Categories - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Browse all categories in the Sunway Multicare Pharmacy Top Choice Awards 2026 competition.'
      }
    },
    { 
      path: '/login', 
      name: 'Login', 
      component: LoginPage,
      meta: {
        title: 'Login - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Login to your Sunway Multicare Pharmacy Top Choice Awards 2026 account.'
      }
    },
    { 
      path: '/register', 
      name: 'Register', 
      component: RegisterPage,
      meta: {
        title: 'Register - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Create an account to participate in Sunway Multicare Pharmacy Top Choice Awards 2026.'
      }
    },
    { 
      path: '/results', 
      name: 'Results', 
      component: ResultsPage,
      meta: {
        title: 'Results - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'View the latest winners of Sunway Multicare Pharmacy Top Choice Awards 2026.'
      }
    },
    {
      path: '/vote',
      name: 'Vote',
      component: () => import('@/views/Vote.vue'),
      meta: {
        title: 'Vote - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Cast your vote for your favorite health products in the Sunway Multicare Pharmacy Top Choice Awards 2026 competition.'
      }
    },
    {
      path: '/user-info',
      name: 'UserInfo',
      component: () => import('@/views/UserInfo.vue'),
      meta: {
        title: 'User Profile - Sunway Multicare Pharmacy Top Choice Awards 2026',
        description: 'Manage your profile and voting history in the Sunway Multicare Pharmacy Top Choice Awards 2026 platform.'
      }
    },
    {
      path: '/admin-login',
      name: 'AdminLogin',
      component: AdminLoginPage,
      meta: {
        title: 'Admin Login - MultiCare Rewards',
        description: 'Admin login for MultiCare Rewards backoffice.'
      }
    },
    {
      path: '/backoffice',
      name: 'Backoffice',
      component: BackofficePage,
      meta: {
        title: 'Backoffice - MultiCare Rewards Admin',
        description: 'Admin panel for managing MultiCare Rewards products and categories.',
        requiresAuth: true
      }
    },
  ]
})

import { security } from '@/utils/security.js'

// Route guard for authentication
router.beforeEach((to, from, next) => {
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!security.isAuthenticated()) {
      security.logActivity('unauthorized_access', { route: to.path })
      next('/admin-login')
    } else {
      security.logActivity('authorized_access', { route: to.path })
      next()
    }
  } else {
    next()
  }
})

export default router
